import { render, staticRenderFns } from "./UserBalanceAddresses.vue?vue&type=template&id=55a1ed64&scoped=true&"
import script from "./UserBalanceAddresses.vue?vue&type=script&lang=js&"
export * from "./UserBalanceAddresses.vue?vue&type=script&lang=js&"
import style0 from "./UserBalanceAddresses.vue?vue&type=style&index=0&id=55a1ed64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a1ed64",
  null
  
)

export default component.exports